import { Theme, createStyles, makeStyles } from '@material-ui/core';
import { LEFT_MENU_WIDTH } from 'utils/Utils';
import { colors } from 'utils/colors';

const TOP_MENU_HEIGHT = 46;

const useLeftMenuStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      paddingTop: 2,
      minWidth: LEFT_MENU_WIDTH,
      height: '100%',
      borderRight: `1px solid ${colors.black10}`,
      backgroundColor: colors.white,
      position: 'relative',
    },
    menuContainer: {
      borderBottom: `1px solid ${colors.black10}`,
      padding: '11px 25px 10px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    itemTxt: {
      fontSize: 16,
      fontWeight: 500,
      color: colors.black,
    },
    listBody: {
      height: `calc(100% - ${TOP_MENU_HEIGHT}px)`,
      overflow: 'auto',
    },
    list: {
      padding: '10px 25px',
      paddingRight: 13,
    },
    menuButton: {
      width: '100%',
      height: 35,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      cursor: 'pointer',
      borderRadius: 5,
      '&:hover': {
        backgroundColor: theme.palette.primary.light,
        '& .MuiTypography-root': {
          color: theme.palette.primary.main,
        },
      },
    },
    menuButtonTxt: {
      color: colors.black54,
      fontSize: 14,
    },
    linkButton: {
      height: 20,
      padding: 3,
      backgroundColor: colors.linkBackground,
      color: colors.black54,
      fontSize: 12,
      border: `1px solid ${colors.black10}`,
    },
  })
);

export default useLeftMenuStyles;
